import MotionLogo from "./motion-logo";

export default MotionLogo;
